/**
 * Generated bundle index. Do not edit.
 */

export * from './pipe-public-api';
